<template>
  <div class="dialog_container">
    <el-dialog
      title="车辆维修记录（返检送修）详情"
      :visible="dialogShow"
      width="837px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">车牌号码：</div>
            <div class="li_text">{{dialogData.carNumber}}</div>
          </li>
          <li>
            <div class="li_title">车牌颜色：</div>
            <div class="li_text">{{dialogData.carColorStr}}</div>
          </li>
          <li>
            <div class="li_title">车辆类型：</div>
            <div class="li_text">{{dialogData.carColorStr}}</div>
          </li>
          <li>
            <div class="li_title">厂牌型号：</div>
            <div class="li_text">{{dialogData.carModel}}</div>
          </li>
          <li>
            <div class="li_title">车辆营运性质：</div>
            <div class="li_text">{{dialogData.carServiceStr}}</div>
          </li>
          <li>
            <div class="li_title">车主单位：</div>
            <div class="li_text">{{dialogData.companyUserName}}</div>
          </li>
          <li>
            <div class="li_title">维修状态：</div>
            <div class="li_text">{{dialogData.repairStateStr}}</div>
          </li>
        </ul>

        <div class="form_title">维修信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">维修企业：</div>
            <div class="li_text">{{dialogData.repairCompanyName}}</div>
          </li>
          <li>
            <div class="li_title">进厂时间：</div>
            <div class="li_text">{{dialogData.factoryTime}}</div>
          </li>
          <li>
            <div class="li_title">进厂里程数：</div>
            <div class="li_text">{{dialogData.factoryMile}}</div>
          </li>
        </ul>

        <div class="form_title">附件</div>
        <div class="uploading_box">
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">进厂图片</div>
              <div v-if="dialogData.factoryImage" class="onebox">
                <div
                  class="twobox"
                  v-if="dialogData.factoryImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + dialogData.factoryImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    dialogData.factoryImage &&
                    dialogData.factoryImage.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + dialogData.factoryImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!dialogData.factoryImage ? true : false"
                  @click="handlePictureCardPreview"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !dialogData.factoryImage ||
                    dialogData.factoryImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn_ok" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
    <preview-image
      :show.sync="dialogVisible"
      :name="dialogImageName"
      :url="dialogImageUrl"
    />
  </div>
</template>

<script>
import config from "@/utils/config";
import previewImage from "@/components/previewImage.vue";
import { downloadFile } from "@/utils/util";
export default {
  name: "",
  data() {
    return {
      textarea: "",
      addForm: {},
      receiveList: [],
      imgHttp: "",
      dialogImageUrl: "",
      dialogImageName: "",
      dialogVisible: false
    };
  },
  components: {
    previewImage
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: {},
    },
  },
  created() {
    this.imgHttp = config.baseUrl;
  },
  methods: {
    confirm() {
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    handlePictureCardPreview() {
      let url = this.dialogData.factoryImage;
      let name = "进厂图片";
      this.dialogImageUrl = this.imgHttp + url;
      this.dialogImageName = name;
      this.dialogVisible = true;
    },
    downs() {
      let url = this.dialogData.factoryImage;
      let name = "进厂图片";
      downloadFile(this.imgHttp + url, name);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.uploading_box {
  display: flex;
  flex-wrap: wrap;
  .certificate {
    width: 360px;
    height: 270px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    margin-bottom: 3px;
    >img{
      width: 100%;
      height: 100%;
    }
  }
  .card_title {
        width: 100%;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        >img{
            width: 6px;
            height: 6px;
        }
      }
}
.info_box {
  >li {
    width: 390px !important;
  }
  .li_3 {
    justify-content: flex-start;
    > div {
      display: flex;
      margin-right: 15px;
    }
    .chenghao {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord_component/detail_1.vue